<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Open Access Publications</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />

      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="searchPublication"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col"></div>
        <div class="col pl-2">
          <div class="float-right">
                 <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New OA Publication
            </v-btn>
          </div>
        </div>
      </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <div v-show="isEdit">
          <div class="row">
            <div class="col">
              <v-text-field
                id="title"
                label="Title*"
                :rules="titleRules"
                v-model="Title"
                required
                return-object
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field v-model="ISBN" label="ISBN" id="isbn"></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-text-field
                id="publisherName"
                v-model="PublisherName"
                label="Publisher Name"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="publisherDate"
                v-model="PublishedDate"
                label="Published Year"
                type="number"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-text-field
                id="citypublication"
                v-model="CityOfPublication"
                label="City Of Publication"
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="countrypublication"
                v-model="CountryOfPublication"
                label="Country Of Publication"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-row>
                <!-- v-show="isEditPublication" -->
                <v-col>
                  <v-checkbox
                    id="default"
                    v-model="isDefaultThumbnail"
                    label="Use default thumbnail"
                    @change="isDefaultThumbnailChanged"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </div>
            <div class="col">
              <v-row>
                <v-col>
                  <div>
                    <!--  :rules="thumbnailRules" v-show="!isDefaultThumbnail"-->
                    <v-file-input
                      id="ThumbnailImage"
                      accept="image/png, image/jpeg"
                      placeholder="Thumbnail"
                      prepend-icon="mdi-camera"
                      label="Thumbnail*"
                      v-model="thumbnailData"
                      @change="loadTumbnail"
                      @click:clear="clearFile"
                      required
                      v-show="!isDefaultThumbnail"
                    ></v-file-input>
                  </div>
                </v-col>
                <v-col class="ThumbnailImg" style="width: 50px">
                  <div class="float-right">
                    <img :src="ThumbnailPath" width="50" id="thubnailImageview" />
                  </div>
                </v-col>
              </v-row>

              <v-text-field
                v-show="false"
                v-model="contributor1"
                label="Contributor"
                id="Contributor"
              ></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <v-textarea
                id="summary"
                clearable
                clear-icon="mdi-close-circle"
                label="Summary*"
                value=""
                v-model="Summary"
                :rules="summaryRules"
                required
                counter
              ></v-textarea>
            </div>
          </div>
          <div class="row" v-show="isEditPublication">
            <!--  v-show="isEditPublication"-->
            <div class="col">
              <file-drop
                v-on:update="logFiles($event)"
                v-on:clear="clearFile"
                :fileName="fileName"
              ></file-drop>
              <div v-show="fileSize > 0">Size: {{ this.fileSize }} MB</div>
            </div>
          </div>

          <div class="row m-1">
            <div class="col">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Additional Fields
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="keyword"
                          v-model="keywords"
                          label="Keywords"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="listprice"
                          v-model="listprice"
                          label="List Price"
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="discount"
                          v-model="discount"
                          label="Discount"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="countryAllowed"
                          v-model="countries_allowed"
                          label="Countries Allowed"
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="bisca"
                          v-model="bisac"
                          label="bisac"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field v-model="lcc" label="lcc" id="lcc"></v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="dewey"
                          v-model="dewey"
                          label="dewey"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="language"
                          v-model="language"
                          label="Language"
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="contributorRole1"
                          v-model="contributorRole1"
                          label="Contributor Role 1"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="contributor1"
                          v-model="contributor1"
                          label="Contributor 1"
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="contributorRole2"
                          v-model="contributorRole2"
                          label="Contributor Role 2"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="contributor2"
                          v-model="contributor2"
                          label="Contributor 2"
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="contributorRole3"
                          v-model="contributorRole3"
                          label="Contributor Role 3"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="contributor3"
                          v-model="contributor3"
                          label="Contributor 3"
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="contributorRole4"
                          v-model="contributorRole4"
                          label="Contributor Role 4"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="contributor4"
                          v-model="contributor4"
                          label="Contributor 4"
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="contributorRole5"
                          v-model="contributorRole5"
                          label="Contributor Role 5"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="contributor5"
                          v-model="contributor5"
                          label="Contributor 5"
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="contributorRole6"
                          v-model="contributorRole6"
                          label="Contributor Role 6"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="Contributor6"
                          v-model="contributor6"
                          label="Contributor 6"
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="contributorRole7"
                          v-model="contributorRole7"
                          label="Contributor Role 7"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="Contributor7"
                          v-model="contributor7"
                          label="Contributor 7"
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="contributorRole8"
                          v-model="contributorRole8"
                          label="Contributor Role 8"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="Contributor8"
                          v-model="contributor8"
                          label="Contributor 8"
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="contributorRole9"
                          v-model="contributorRole9"
                          label="Contributor Role 9"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          v-model="contributor9"
                          label="Contributor 9"
                          id="Contributor9"
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <v-text-field
                          id="contributorRole10"
                          v-model="contributorRole10"
                          label="Contributor Role 10"
                        ></v-text-field>
                      </div>
                      <div class="col">
                        <v-text-field
                          id="Contributor10"
                          v-model="contributor10"
                          label="Contributor 10"
                        ></v-text-field>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col">
              <div class="float-right action-area">
                <v-btn @click="onCancel()"> Cancel </v-btn>
                <v-btn
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-form>

      <div class="row" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Title</th>
                  <th class="text-left">Publisher</th>
                  <th class="text-left">ISBN</th>
                  <th class="text-left">Contributor</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'svg' + i">
                  <td id="cont$(item.id)">{{ item.Title }}</td>
                  <td>{{ item.PublisherName }}</td>
                  <td>{{ item.ISBN }}</td>
                  <td>{{ item.contributor1 }}</td>
                  <td>
                    <v-icon class="mr-2 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-2 icon-delete" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import FileDrop from "../components/FileDrop";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import VueUploadComponent from "vue-upload-component";
import Pagination from "@/components/Pagination";
import * as api from "@/api";
import axios from "axios";
import { Parser } from "json2csv";

export default {
  name: "Publications",
  components: {
    Notification,
    FileUpload: VueUploadComponent,
    FileDrop,
    ConfirmationDialog,
    Pagination
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    isEditPublication() {
      return this.id === 0 ? true : false;
    },
    resultQuery() {
      if (this.Search) {
        return this.list.filter(item => {
          return this.Search.toLowerCase()
            .split(" ")
            .every(v => item.title.toLowerCase().includes(v));
        });
      } else {
        return this.list;
      }
    }
  },
  created() {
    this.getPublicationByPagin();
    //this.getAuthors();
    /*
    this.getSuppliers();
    this.getPublishers();
    this.getCategories();
    this.getSubCategories();
    */
  },
  beforeMount() {},
  methods: {
    onDownloadPublications() {
      api.getAll("publications").then(response => {
        this.exportData = response.data;
        this.downloadPublicationMetadataAsCSV(this.exportData);
      });
    },
    downloadPublicationMetadataAsCSV(json) {
      const parser = new Parser();
      const csv = parser.parse(
        json.map(pub => this.mapPublicationMetadataToCSVRecord(pub))
      );

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      var link = document.createElement("a");
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "publications-metadata.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    mapPublicationMetadataToCSVRecord(pub) {
      return {
        Title: pub.Title,
        ISBN: pub.ISBN,
        "Publisher name": pub.PublisherName,
        "Published year": pub.PublishedDate,
        "City of publication": pub.CityOfPublication,
        "Country of publication": pub.CountryOfPublication,
        Keywords: pub.keywords,
        "List price": pub.listprice,
        Discount: pub.discount,
        "Countries allowed": pub.countries_allowed,
        bisac: pub.bisac,
        Lcc: pub.lcc,
        dewey: pub.dewey,
        Language: pub.language,
        "Contributor role 1": pub.contributorRole1,
        "Contributor 1": pub.contributor1,
        "Contributor role 2": pub.contributorRole2,
        "Contributor 2": pub.contributor2,
        "Contributor role 3": pub.contributorRole3,
        "Contributor 3": pub.contributor3,
        "Contributor role 4": pub.contributorRole4,
        "Contributor 4": pub.contributor4,
        "Contributor role 5": pub.contributorRole5,
        "Contributor 5": pub.contributor5,
        "Contributor role 6": pub.contributorRole6,
        "Contributor 6": pub.contributor6,
        "Contributor role 7": pub.contributorRole7,
        "Contributor 7": pub.contributor7,
        "Contributor role 8": pub.contributorRole8,
        "Contributor 8": pub.contributor8,
        "Contributor role 9": pub.contributorRole9,
        "Contributor 9": pub.contributor9,
        "Contributor role 10": pub.contributorRole10,
        "Contributor 10": pub.contributor10
      };
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getPublicationByPagin();
    },
    onNew() {
      this.notify.type = 0;
      this.isEdit = true;
      this.id = 0;
      this.Title = "";
      this.ISBN = "";
      this.Edition = "";
      this.Summary = "";
      this.AuthorName = "";
      this.ThumbnailPath = "";
      this.author_id = -1;
      this.publisher_id = -1;
      this.supplier_id = -1;
      this.category_id = -1;
      this.sub_category_id = -1;
      this.files = [];
      this.file = {};
      this.thumbnail = null;
      this.fileName = "";
      this.PublisherName = "";
      this.PublishedDate = "";
      this.CityOfPublication = "";
      this.CountryOfPublication = "";
      this.ThumbnailFileType = "";
      this.PublicationFileType = "";
      this.thumbnailUrl = "";
      this.thumbnailFileName = "";
      this.isDefaultThumbnailChanged = false;
      this.isDefaultThumbnail = false;
      this.fileSize = 0;
      this.isImported = false;
      this.this.keywords = "";
      this.listprice = 0;
      this.discount = 0;
      this.countries_allowed = "";
      this.bisac = "";
      this.lcc = "";
      this.dewey = "";
      this.language = "";
      this.contributorRole1 = "";
      this.contributor1 = "";
      this.contributorRole2 = "";
      this.contributor2 = "";
      this.contributorRole3 = "";
      this.contributor3 = "";
      this.contributorRole4 = "";
      this.contributor4 = "";
      this.contributorRole5 = "";
      this.contributor5 = "";
      this.contributorRole6 = "";
      this.contributor6 = "";
      this.contributorRole7 = "";
      this.contributor7 = "";
      this.contributorRole8 = "";
      this.contributor8 = "";
      this.contributorRole9 = "";
      this.contributor9 = "";
      this.contributorRole10 = "";
      this.contributor10 = "";
    },
    onSave() {
      let that = this;
      that.overlay = true;
      this.selectedObj.file = this.file;
      this.selectedObj.fileName = this.fileName;

      if (this.thumbnailFileName != "")
        this.ThumbnailFileType = this.thumbnailFileName.split(".").pop();

      if (this.fileName != "")
        this.PublicationFileType = this.fileName.split(".").pop();

      //if (this.thumbnailUrl != "File: Default_Thumbnail.jpg") {
      //this.ThumbnailFileType = this.thumbnailFileName.split(".").pop();
      //}

      if (this.ThumbnailPath.includes("data:image")) {
        this.ThumbnailPath = "";
      }

      console.log(this.ThumbnailFileType);

      this.$refs.form.validate();

      if (this.valid) {
        if (!this.validateFrom()) {
          const publication = {
            id: this.id,
            uuid: this.uuid,
            Title: this.Title,
            ISBN: this.ISBN,
            Edition: this.Edition,
            Summary: this.Summary,
            AuthorName: this.AuthorName,
            ThumbnailPath: this.ThumbnailPath,
            Author: this.Author,
            publisher_id: this.publisher_id,
            supplier_id: this.supplier_id,
            category_id: this.category_id,
            sub_category_id: this.sub_category_id,
            file: this.file,
            fileName: this.fileName,
            thumbnail: this.thumbnail,
            thumbnailFileName: this.thumbnailFileName,
            PublisherName: this.PublisherName,
            PublishedDate: this.PublishedDate,
            CityOfPublication: this.CityOfPublication,
            CountryOfPublication: this.CountryOfPublication,
            ThumbnailFileType: this.ThumbnailFileType,
            PublicationFileType: this.PublicationFileType,
            isDefaultThumbnail: this.isDefaultThumbnail,
            isImported: this.isImported,

            keywords: this.keywords,
            listprice: this.listprice,
            discount: this.discount,
            countries_allowed: this.countries_allowed,
            bisac: this.bisac,
            lcc: this.lcc,
            dewey: this.dewey,
            language: this.language,
            contributorRole1: this.contributorRole1,
            contributor1: this.contributor1,
            contributorRole2: this.contributorRole2,
            contributor2: this.contributor2,
            contributorRole3: this.contributorRole3,
            contributor3: this.contributor3,
            contributorRole4: this.contributorRole4,
            contributor4: this.contributor4,
            contributorRole5: this.contributorRole5,
            contributor5: this.contributor5,
            contributorRole6: this.contributorRole6,
            contributor6: this.contributor6,
            contributorRole7: this.contributorRole7,
            contributor7: this.contributor7,
            contributorRole8: this.contributorRole8,
            contributor8: this.contributor8,
            contributorRole9: this.contributorRole9,
            contributor9: this.contributor9,
            contributorRole10: this.contributorRole10,
            contributor10: this.contributor10
          };
          const jsonStringValues = JSON.stringify(publication);
          console.log("jsonStringValues " + jsonStringValues);

          //const formData = new FormData();
          //formData.append("file", this.file);
          //formData.append("data", publication);
          this.loading = true;
          new Promise((resolve, reject) => {
            api
              //.update("publications", this.selectedObj) //updateFile
              .update("open-access-publications", publication)
              .then(response => {
                resolve(response);
                console.log(response.status);
                console.log(response);
                if (response.status === 200 || response.status === 201) {
                  this.isEdit = false;
                  this.notify.type = 1;
                  this.notify.message =
                    this.selectedObj.id === 0
                      ? "Record successfully saved."
                      : "Record successfully updated.";
                  this.loading = false;
                  this.getPublicationByPagin();
                  setTimeout(() => {
                    this.notify.type = 0;
                  }, 3000);
                } else {
                  this.loading = false;
                  this.notify.type = 4;
                  this.notify.errors.push("Failed to save data.");
                }
                that.overlay = false;
              })
              .catch(error => {
                if (error.message == "Request failed with status code 409") {
                  this.notify.type = 4;
                  this.notify.errors.push("ISBN already exist.");
                  this.loading = false;
                  reject(error);
                } else {
                  this.notify.type = 4;
                  this.notify.errors.push("Failed to save data. " + error);
                  console.log(error);
                  this.loading = false;
                  reject(error);
                }
                that.overlay = false;
              });
          });

          this.$refs.form.reset();
        }
      }
    },
    uploadToLCP() {
      new Promise((resolve, reject) => {
        api
          .update("publications", formData)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    validateFrom() {
      this.notify.errors.splice(0, this.notify.errors.length);
      this.notify.type = 4;

      console.log("File " + this.id);
      console.log(this.selectedObj.fileName);

      if (this.fileName === "" && this.id == 0) {
        this.notify.errors.push("Publication is required.");
        return true;
      }
      console.log(this.selectedObj.fileName);
      var fileExt = this.selectedObj.fileName.split(".").pop();
      if (fileExt == "epub") {
        // || fileExt == "pdf" || fileExt == "lpf"
      } else {
        if (this.id == 0) {
          this.notify.errors.push("Invalid publication type.");
          return true;
        }
      }
      if (this.fileSize >= 25) {
        this.notify.errors.push("Publication size should be less the 25MB.");
        return true;
      }

      if (
        !this.isDefaultThumbnail &&
        this.isEditPublication &&
        (this.thumbnailFileName == "" || this.ThumbnailPathOld != "")
      ) {
        this.notify.errors.push("Thumbnail is required.");
        return true;
      }
      return false;
    },
    onEdit(obj) {
      this.$refs.form.resetValidation();
      this.isEdit = true;
      obj.file = {};
      //this.selectedObj = Object.assign({}, obj);
      this.id = obj.id;
      this.uuid = obj.uuid;
      this.Title = obj.Title;
      this.ISBN = obj.ISBN;
      this.Edition = obj.Edition;
      this.AuthorName = obj.AuthorName;
      this.Author = obj.Author;
      this.publisher_id = obj.publisher_id;
      this.supplier_id = obj.supplier_id;
      this.category_id = obj.category_id;
      this.sub_category_id = obj.sub_category_id;
      this.Summary = obj.Summary;
      this.PublisherName = obj.PublisherName;
      this.PublishedDate = obj.PublishedDate;
      //this.date =   obj.PublishedDate == null  ? null : new Date(obj.PublishedDate).toISOString().substr(0, 10);
      this.CityOfPublication = obj.CityOfPublication;
      this.CountryOfPublication = obj.CountryOfPublication;
      this.thumbnail = "";
      this.ThumbnailFileType = obj.ThumbnailFileType;
      //this.thumbnailData =  obj.ThumbnailFileType == "" ? "": obj.uuid + "." + obj.ThumbnailFileType;
      this.isDefaultThumbnail = obj.isDefaultThumbnail;
      this.ThumbnailPath = obj.ThumbnailPath;
      this.ThumbnailPathOld = obj.ThumbnailPath;
      //this.thumbnailUrl = obj.ThumbnailFileType == "" ? "File: Default_Thumbnail.jpg" : "File: " + obj.uuid + "." + obj.ThumbnailFileType;
      //https://storage.googleapis.com/prothumia/eBooks/  https://storage.googleapis.com/prothumia-publications-thumbnail/' +

      this.isImported = obj.isImported;
      this.keywords = obj.keywords;
      this.listprice = obj.listprice;
      this.discount = obj.discount;
      this.countries_allowed = obj.countries_allowed;
      this.bisac = obj.bisac;
      this.lcc = obj.lcc;
      this.dewey = obj.dewey;
      this.language = obj.language;
      this.contributorRole1 = obj.contributorRole1;
      this.contributor1 = obj.contributor1;
      this.contributorRole2 = obj.contributorRole2;
      this.contributor2 = obj.contributor2;
      this.contributorRole3 = obj.contributorRole3;
      this.contributor3 = obj.contributor3;
      this.contributorRole4 = obj.contributorRole4;
      this.contributor4 = obj.contributor4;
      this.contributorRole5 = obj.contributorRole5;
      this.contributor5 = obj.contributor5;
      this.contributorRole6 = obj.contributorRole6;
      this.contributor6 = obj.contributor6;
      this.contributorRole7 = obj.contributorRole7;
      this.contributor7 = obj.contributor7;
      this.contributorRole8 = obj.contributorRole8;
      this.contributor8 = obj.contributor8;
      this.contributorRole9 = obj.contributorRole9;
      this.contributor9 = obj.contributor9;
      this.contributorRole10 = obj.contributorRole10;
      this.contributor10 = obj.contributor10;
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("open-access-publications", obj.id)
            .then(response => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                setTimeout(() => {
                  this.notify.type = 0;
                  this.getPublicationByPagin();
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch(error => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
      this.isEdit = false;
    },
    onCancel() {
      this.isEdit = false;
      this.notify.type = 0;
      this.notify.errors.splice(0, this.notify.errors.length);
    },
    getPublications() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("open-access-publications", this.paging)
          .then(response => {
            this.list = response.data;
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getPublicationByPagin();
    },
    getPublicationByPagin() {
      let that = this;
      that.overlay = true;
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("open-access-publications", this.paging)
          .then(response => {
            this.list = response.data.data;
            this.paging.count = response.data.count;
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getAuthors() {
      this.authors = [];
      new Promise((resolve, reject) => {
        api
          .getAll("author")
          .then(response => {
            this.authors = response.data;
            //this.authors.splice(0, 0, { id: -1, firstName: "" });
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getPublishers() {
      this.publishers = [];
      new Promise((resolve, reject) => {
        api
          .getAll("publishers")
          .then(response => {
            this.publishers = response.data;
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getSuppliers() {
      this.suppliers = [];
      new Promise((resolve, reject) => {
        api
          .getAll("suppliers")
          .then(response => {
            this.suppliers = response.data;
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getCategories() {
      this.categories = [];
      new Promise((resolve, reject) => {
        api
          .getAll("categories")
          .then(response => {
            this.categories = response.data;
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getSubCategories() {
      this.subCategoriess = [];
      new Promise((resolve, reject) => {
        api
          .getAll("subcategories")
          .then(response => {
            this.subCategories = response.data;
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    handleFileDrop(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      {
        this.files.push(droppedFiles[0]);
      }

      /*
      [...droppedFiles].forEach((f) => {
        this.files.push(f);
      });*/
    },
    handleFileInput(e) {
      let files = e.target.files;
      if (!files) return;
      //[...files].forEach((f) => {
      //this.files.push(f);
      // });
    },
    removeFile(fileKey) {
      this.files.splice(fileKey, 1);
    },
    fileDragIn() {
      this.color = "white";
    },
    fileDragOut() {
      this.color = "#eefaff";
    },

    logFiles(fileList) {
      const reader = new FileReader();
      reader.onload = e => {
        console.log(" result " + e);

        const text = reader.result.toString().trim();
        this.file = text;
      };
      this.fileSize = 0;
      reader.readAsDataURL(fileList[0]);
      this.fileName = fileList[0].name;
      console.log(this.fileName);
      console.log(fileList[0].size);

      this.fileSize = (fileList[0].size / (1024 * 1024)).toFixed(2);
    },
    loadTumbnail(e) {
      this.thumbnailFileName = this.thumbnailData.name;
      const reader = new FileReader();
      reader.readAsDataURL(this.thumbnailData);
      //reader.onload = () => resolve(reader.result); // reader.result
      reader.onload = result => {
        console.log(result.currentTarget.result);
        this.thumbnail = result.currentTarget.result;
        this.ThumbnailPath = result.currentTarget.result;
      };
      reader.onerror = error => reject(error);
    },
    clearFile() {
      this.ThumbnailPath = "";
      this.fileSize = false;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    isDefaultThumbnailChanged() {
      if (this.isDefaultThumbnail) {
        this.thumbnailUrl = "File: Default_Thumbnail.jpg";
        this.ThumbnailPath =
          "https://storage.googleapis.com/prothumia/eBooks/Default_Thumbnail.png";
      } else {
        this.thumbnailUrl =
          "File: " + this.uuid + "." + this.ThumbnailFileType == ""
            ? "jpg"
            : this.ThumbnailFileType;
        this.ThumbnailPath = this.ThumbnailPathOld;
      }

      //this.thumbnailUrl = this.ThumbnailFileType == "" ? "File: Default_Thumbnail.jpg" : "File: " + this.uuid + "." + this.ThumbnailFileType;
    }
  },
  data: () => ({
    valid: false,
    id: 0,
    uuid: "",
    Title: "",
    ISBN: "",
    Edition: "",
    thumbnail: "",
    thumbnailData: "",
    thumbnailFileName: "",
    ThumbnailPath: "",
    Summary: "",
    AuthorName: "",
    PublisherName: "",
    PublishedDate: "",
    CityOfPublication: "",
    CountryOfPublication: "",
    PublicationFileType: "",
    ThumbnailFileType: "",
    Author: {},
    publisher_id: -1,
    supplier_id: -1,
    category_id: -1,
    sub_category_id: -1,
    list: [],
    authors: [],
    publishers: [],
    suppliers: [],
    categories: [],
    subCategories: [],
    isEdit: false,
    isNew: false,
    Search: "",
    date: "",
    selectedObj: {},
    notify: {
      type: 0,
      message: "",
      errors: []
    },
    files: [],
    file: {},
    fileName: "",
    color: "#eefaff",
    titleRules: [v => !!v || "Title is required"],
    summaryRules: [
      v => !!v || "Summary is required",
      v =>
        (v && v.length <= 2000) || "Summary must be less than 2000 characters"
    ],
    thumbnailRules: [
      v =>
        (!!v && isDefaultThumbnail) ||
        "Thumbnail is required" ||
        !v ||
        v.size < 2000000 ||
        "Thumbnail size should be less than 2 MB!"
    ],
    publishedDateRules: [v => !!v || "Published date  is required"],
    menu2: false,
    isDefaultThumbnail: false,
    thumbnailUrl: "",
    loading: false,
    paging: { count: 10, page: 1, size: 10, keyword: "" },
    fileSize: 0,
    ThumbnailPath: "",
    ThumbnailPathOld: "",
    hover: false,
    keywords: "",
    listprice: 0,
    discount: 0,
    countries_allowed: "",
    bisac: "",
    lcc: "",
    dewey: "",
    language: "",
    contributorRole1: "",
    contributor1: "",
    contributorRole2: "",
    contributor2: "",
    contributorRole3: "",
    contributor3: "",
    contributorRole4: "",
    contributor4: "",
    contributorRole5: "",
    contributor5: "",
    contributorRole6: "",
    contributor6: "",
    contributorRole7: "",
    contributor7: "",
    contributorRole8: "",
    contributor8: "",
    contributorRole9: "",
    contributor9: "",
    contributorRole10: "",
    contributor10: "",
    isImported: false,
    overlay: false
  })
};
</script>
<style scoped>
.action-area {
  padding-top: 5px;
}
.container-file {
  border: 2px dashed lightslategrey;
  height: 80px;
  background: rgb(238, 250, 255);
  text-align: center;
}
.fileText {
  margin: auto;
}
.file-wrapper {
  text-align: center;
  height: 80px;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  overflow: hidden;
  background: rgb(238, 250, 255);
}
.file-wrapper input {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  font-size: 300px;
  height: 200px;
}
.icon-edit {
  color: #1975d2;
}
.icon-delete {
  color: red;
}
.col {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/OAPublications.vue